<template>
<DialogBox title="Sort Items" :settings="settings" @save="save" @show="initialise">
    <div class="pa-2">

    <v-btn-toggle dense v-model="exportPreferences" multiple>
        <v-btn text>
        Main
        </v-btn>
        <v-btn text>
        Contacts
        </v-btn>
        <v-btn text>
        Files
        </v-btn>
        <v-btn text>
        Comments
        </v-btn>
        <v-btn text>
        Emails
        </v-btn>
    </v-btn-toggle>

    <v-btn-toggle dense v-model="exportFormat" class="ml-2" mandatory>
        <v-btn>
            HTML
        </v-btn>
        <v-btn>
            Text
        </v-btn>
    </v-btn-toggle>
    </div>

    <!-- HTML Version -->
    <div v-if="exportFormat == exportFormatOptions.HTML" style="overflow-y:auto" ref="export">
    <div style="padding:10px;max-width:600px;">

    <!-- Transaction -->
    <template v-if="exportPreferences.includes(exportOptions.TRANSACTION)">
    <div :style="headingStyle">{{transactionDetails.clients}}</div>

        <div v-for="element in importantElements" style="display:flex;" :key="element.key">
            <div style="font-weight:bolder;padding:10px;flex-basis:200px;min-width:200px;background-color:#ddd;margin:1px">
                {{element.title}}
            </div>
            <div style="padding:10px;flex-grow:1" v-html="element.value">
                
            </div>
        </div>
    </template>

    <!-- Contacts -->
    <template v-if="exportPreferences.includes(exportOptions.CONTACTS)">
        <div :style="headingStyle">Contacts</div>
        <div v-for="contact in contacts" style="display:flex;" :title="JSON.stringify(contact)" :key="contact['.key']">
            <img :src="contact.image" width="60px" style="flex-basis:40px;margin:5px;border-radius:50%"/>
            <div style="flex-grow;padding:3px">
                <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{{contact | fullName}}</div>
                <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#555">{{phoneNumbers(contact)}}</div>
            </div>
        </div>
    </template>

    <!-- Files -->
    <template v-if="exportPreferences.includes(exportOptions.FILES)">
        <div :style="headingStyle">Files</div>
        <a v-for="element in fileElements" :href="element.value" target="_blank" :key="element.key">
            <div class="hoverable" style="width:100px;padding:10px;display:inline-block" :title="element.title">
                <img :src="imagePath" width="80px"/>
                <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{{element.title}}</div>
            </div>
        </a>
    </template>

    <!-- Comment History -->
    <template v-if="exportPreferences.includes(exportOptions.COMMENTS)">
        <div :style="headingStyle">Comment History</div>
        <div v-for="comment in comments" :key="comment['.key']" style="padding:10px;">
            {{comment.text}} <span style="color:#888"> - {{comment.stamp|fullName}} {{comment.stamp.date|date}}</span>
        </div>
    </template>

    <!-- Email History -->
    <template v-if="exportPreferences.includes(exportOptions.EMAILS)">
        <div :style="headingStyle">Email History</div>
        <div v-for="mailLogItem in mailLog" :key="mailLogItem['id']" style="padding:10px;">
            From: {{mailLogItem.email.from}} <br/>
            To: {{mailLogItem.email.to.map(recipient => recipient.email).join(', ')}} <br/>
            Subject: {{mailLogItem.email.subject}}<br/>
            Body: {{removeHtml(mailLogItem.email.body)}}<br/><br/>
        </div>
    </template>
        
    </div>
    </div>

    <!-- Text Version -->
    <div v-if="exportFormat == exportFormatOptions.TEXT" class="full-width pa-3">
    <textarea :value = "allText" rows="10" style="width:100%;border:solid 1px #eee;">
    </textarea>
    </div>

</DialogBox>
</template>

<script>
import clipboard from 'clipboard-js'
import DataHelpers from '../helpers/DataHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import DateHelpers from '../helpers/DateHelpers'
import draggable from 'vuedraggable'
import NiceData from '../data/NiceData'
import OrderHelpers from '../helpers/OrderHelpers'
import DialogBox from '../ui-elements/DialogBox'
import ElementsStore from '../store/ElementsStore'
import StringHelpers from '../helpers/StringHelpers'
import { debug } from 'util'
import ContactHelpers from '../helpers/ContactHelpers'
import LoanHelpers from '../helpers/LoanHelpers'

export default {
    inject: ['loadMailFunction'],
    data() {
        return {
            historyElement: {},
            transactionDetails: {},
            comments: [],
            exportPreferences: [0, 1, 2, 3],
            exportOptions: {
                TRANSACTION: 0, 
                CONTACTS:1, 
                FILES:2, 
                COMMENTS:3,
                EMAILS: 4,
            },
            exportFormat: 0,
            exportFormatOptions: {
                HTML: 0, 
                TEXT:1, 
            }, 
            exportText: '',
            mailLog: [],   
        }
    },
    components: {
        draggable,
        DialogBox,
    },
    
    props: {
        settings: Object,
        elements: Array,
    },

    computed: {
        // exportHtml() {
        //     let 
        //     try {
        //         return this.$refs.export.innerHTML
        //     } catch (e) {
        //         return 'loading...'
        //     }
        // },

        exportString() {
            if(this.exportFormat == this.exportFormatOptions.HTML) {
                const html = this.$refs.export.innerHTML
                return html
            } else {
                return this.allText
            }
        },
        
        headingStyle() {
            return `font-size:20px;color:#5DADE2;margin:10px 0;`
        },
        imagePath() {
            return StringHelpers.imagePath() + '/document-simple.svg'
        },

        // transactionComments() {
        //     let comments =  this.$store.getters.transactionComments
        //     return comments
        // },  

        importantElements() {
            return this.elements.filter(o => o.important)
        },

        fileElements() {
            return this.elements.filter(o => o.type == 'File')
        },

        contacts() {
            return this.elements.filter(o => o.type == 'Contact').map(o => o.contact)
        },

        importantElementsStr() {
            let str = ''
            this.elements.forEach(element => {
                if(element.important) {
                    str += '<b>' + element.title + ':</b> ' +  element.value + '<br/>'
                }

            })
            return str
        },
        transactionText() {
            let str = `*** ${this.transactionDetails.clients} ***`
            this.importantElements.forEach(element => {
                str = this.addLine(str, element.title + ': ' + this.checkForLoanDiagram(element))
            })
            return str
        },

        contactsText() {
            let str = '*** CONTACTS ***'
            this.contacts.forEach(contact => {
                str = this.addLine(str, ContactHelpers.fullName(contact))
                str = this.addLine(str, ContactHelpers.phoneNumbers(contact))
                str = this.addLine(str, '---')
            })
            return str
        },
        commentsText() {
            let str = '*** COMMENTS ***'
            this.comments.forEach(comment => {
                str = this.addLine(str, comment.text)
                str = this.addLine(str, DateHelpers.backwardsToAu(comment.stamp.date) + ' - ' + ContactHelpers.fullName(comment.stamp))
                str = this.addLine(str, '---')
            })
            return str
        },
        filesText() {
            let str = '*** FILES ***'
            this.fileElements.forEach(file => {
                str = this.addLine(str, file.title)
                str = this.addLine(str, file.value)
                str = this.addLine(str, DateHelpers.backwardsToAu(file.stamp.date) + ' - ' + ContactHelpers.fullName(file.stamp))
                str = this.addLine(str, '---')
            })
            return str
        },
        emailsText() {
            let str = '*** EMAILS ***'

            this.mailLog.forEach(mailLogItem => {
                str = this.addLine(str, 'From: ' + mailLogItem.email.from)
                str = this.addLine(str, 'To: ' + mailLogItem.email.to.map(recipient => recipient.email).join(', '))
                str = this.addLine(str, 'Subject: ' + mailLogItem.email.subject)
                str = this.addLine(str, 'Body: ' + this.removeHtml(mailLogItem.email.body) )
                str = this.addLine(str, '\n')

            })

            return str
        },
        allText() {
            let str = ''
            if(this.exportPreferences.includes(this.exportOptions.TRANSACTION))
                str = this.addLine(str, this.transactionText)
            if(this.exportPreferences.includes(this.exportOptions.CONTACTS))
                str = this.addLine(str, this.contactsText)
            if(this.exportPreferences.includes(this.exportOptions.FILES))
                str = this.addLine(str, this.filesText)
            if(this.exportPreferences.includes(this.exportOptions.COMMENTS))
                str = this.addLine(str, this.commentsText)
            if(this.exportPreferences.includes(this.exportOptions.EMAILS))
                str = this.addLine(str, this.emailsText)

            return str
        }

    },

    methods: {
        removeHtml(html) {
            return StringHelpers.removeHtml(html, true)
        },

        save () {
            clipboard.copy({'text/html': this.exportString})
            AlertHelpers.showAlert('Copied to clipboard')
            this.$emit('save', this.settings)
        },

        phoneNumbers(contact) {
            return ContactHelpers.phoneNumbers(contact)
        },
        loadComments() {
            let ref = DataHelpers.getTransactionRef().child('comments')
            NiceData.fetchItemsFromFirebase(ref).then(comments => {
                this.comments = comments.sort(OrderHelpers.sortByTimestampDescending)
            })
        },

        loadTransactionDetails() {
            let ref = DataHelpers.getTransactionRef().child('details')
            NiceData.fetchItemSingle(ref).then(details => {
                this.transactionDetails = details
            })
        },

        initialise() {
            
        },

        addLine(originalText, addText) {
            if(originalText && addText) 
                originalText += '\n'
            originalText += addText
            return originalText
        },

        checkForLoanDiagram(element) {
            if(element.name == 'loan_diagram') {
                let diagramDetails = LoanHelpers.diagramDetails(element.diagram)
                const desc = LoanHelpers.diagramDescription(diagramDetails)
                return StringHelpers.removeHtml(desc)
            }
            else
                return element.value
        },

        async loadMail() {
            this.mailLog = await this.loadMailFunction()
        }

    },

    created() {
        this.settings.saveLabel = 'Copy to Clipboard'
        this.loadComments()
        this.loadTransactionDetails()
        this.loadMail()
    
    },

    mounted() {
        this.historyElement = this.$refs.export
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// ExporterDialog.vue?02b04d20